import { useTranslation } from 'react-i18next'

import { RENTAL_PORTAL_FACT_SEPARATOR } from '../../../../../constants/rentalPortal'
import { useContentOverflow } from '../../../../../hooks'
import { FloatingTooltip } from '../../../../Floating'
import { getListingUnitLabel } from '../../../../RentalPortalListing'
import Text from '../../../../Text'
import { QA_NAME_OVERVIEW_COMMUNICATION_SUBJECT } from '../RentalPortalOverviewCommunicationRow.constants'

import * as styles from './OverviewCommunicationSubtitle.module.css'

function OverviewCommunicationSubtitle({ row }) {
  const { t } = useTranslation()

  const unitLabel = getListingUnitLabel({ listing: row, t })

  const {
    overflow: hasSubjectOverflow,
    setContentOverflowRef: setSubjectOverflowRef,
  } = useContentOverflow({ dep: [row.subject] })
  const {
    overflow: hasUnitOverflow,
    setContentOverflowRef: setUnitOverflowRef,
  } = useContentOverflow({ dep: [unitLabel] })

  return (
    <span className={styles.OverviewCommunicationSubtitle}>
      <FloatingTooltip content={row.subject} disabled={!hasSubjectOverflow}>
        <Text
          isSecondary
          className={styles.subject}
          qaName={QA_NAME_OVERVIEW_COMMUNICATION_SUBJECT}
          ref={setSubjectOverflowRef}
        >
          {row.subject}
        </Text>
      </FloatingTooltip>
      {unitLabel ? (
        <>
          <Text isSecondary className={styles.dot}>
            {RENTAL_PORTAL_FACT_SEPARATOR}
          </Text>
          <FloatingTooltip content={unitLabel} disabled={!hasUnitOverflow}>
            <Text isSecondary className={styles.unit} ref={setUnitOverflowRef}>
              {unitLabel}
            </Text>
          </FloatingTooltip>
        </>
      ) : null}
    </span>
  )
}

export default OverviewCommunicationSubtitle
